import { useQuery } from '@tanstack/react-query'
import { contentfulApi } from '../services/contentfulService'
import { useMemo } from 'react'

/**
 * Hook refactorizado para obtener datos de Premium
 * @returns {Object} Datos procesados de Premium
 */
export const useContentfulPremium = () => {
	const {
		data,
		isLoading: loading,
		error,
		refetch,
		isStale,
		isRefetching
	} = useQuery({
		queryKey: ['contentful', 'premium'],
		queryFn: contentfulApi.getPremium,
		staleTime: 5 * 24 * 60 * 60 * 1000, // 5 días
		cacheTime: 5 * 24 * 60 * 60 * 1000, // 5 días
		retry: 2,
		retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
		refetchOnWindowFocus: false,
		refetchOnReconnect: true
	})

	// Procesar datos usando useMemo para evitar recálculos innecesarios
	const isContentPremium = useMemo(() => {
		if (!data?.homeCollection?.items?.[0]?.estadosPremium?.referenciaContenidoCollection?.items) {
			return false
		}

		const items = data.homeCollection.items[0].estadosPremium.referenciaContenidoCollection.items
		let newData: Record<string, any> = {}

		items?.forEach((e: any) => {
			newData = {
				...newData,
				[e?.id]: e
			}
		})

		return newData
	}, [data])

	// Información del cache
	const cacheInfo = useMemo(() => {
		const now = new Date()
		const cacheExpiry = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)
		return {
			cacheExpiry,
			lastUpdated: now
		}
	}, [])

	// Logging para debugging
	if (error) {
		console.error('Error en useContentfulPremium:', error)
	}

	return {
		loading,
		error,
		isContentPremium,
		refetch,
		isStale,
		isRefetching,
		cacheInfo,
		rawData: data
	}
}

export default useContentfulPremium
